/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Updated At: 18 de 05 de 2026
 */

import React from 'react';
import { InputAdornment, Box } from '@mui/material';
import { CustomTextField } from "../../components/CustomTextField";
import { CustomPassword } from "../../components/CustomPassword";
import CustomOtpInput from "../../components/CustomOtpInput";
import { ButtonNextStep } from "../../components/buttons/ButtonNavigation";
import CustomInputLabel from "../../components/CustomInputLabel";
import FullPageLoader from "../../utils/FullPageLoader";
import HomeApp from "./Functionality/HomeApp";
import { EmailSubsectionChip, IconLogoIEntry } from '../../components/buttons/IconButtons';
import HomeAnimatedBackground from "./Subcomponents/HomeAnimatedBackground";

const Home = () => {
    const {
        t,
        emptyFields,
        email,
        setEmail,
        password,
        setPassword,
        loading,
        isValidEmail,
        isValidOtp,
        setIsValidOtp,
        otp,
        setOtp,
        showOtp,
        handleEmailChange,
        handleKeyDown,
        handleLogin,
        handleForgotPassword
    } = HomeApp();

    if (sessionStorage?.getItem("bearerToken")) return null;

    return (
        <>
            <div className={'d-flex w-100vw h-100vh overflow-hidden row'}>
                <div className="col-12 col-lg-5 flex-fill d-flex flex-column justify-content-center align-items-center position-relative p-5">
                    <div className="w-100 maxw-360px d-flex flex-column">
                        <form onSubmit={(e) => e.preventDefault()}>
                            <Box className="center-text p-0 mb-3">
                               <IconLogoIEntry className={'icon-color-primary-700'} width={33} height={44}/>
                            </Box>
                            <div className="text-center font-color-general-950 fs-14px mb-3 ibl-font-w-400">
                                <CustomInputLabel
                                    labelId="lbl_hm_version_number"
                                    trans={t("1.0.74")}
                                />
                            </div>
                            <p className="d-flex justify-content-center fs-32px
                            font-color-general-950 ibl-font-w-600 mb-1 p-0">
                                {t('welcome')}
                            </p>
                            <div className="fs-16px text-center font-color-shades-700 mb-5">
                                {t('please_enter_credentials')}
                            </div>

                            <div className={'p-0'}>
                                <CustomTextField
                                    id="txt_hm_email"
                                    length={128}
                                    name="email"
                                    value={email}
                                    trans="email"
                                    type="text"
                                    disabled={false}
                                    onChange={(e) => {
                                        setEmail(e.target.value);
                                        handleEmailChange(e);
                                    }}
                                    required={true}
                                    emptyFields={emptyFields}
                                    isValid={isValidEmail}
                                    isValidText="email_format_invalid"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <EmailSubsectionChip className='w-24px h-24px' />
                                            </InputAdornment>
                                        ),
                                    }}
                                    onKeyDown={handleKeyDown}
                                />
                                <CustomPassword
                                    id="txt_hm_password"
                                    name="password"
                                    length={64}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    label="password"
                                    required={true}
                                    emptyFields={emptyFields}
                                    onKeyDown={handleKeyDown}
                                />
                            </div>

                            {showOtp &&
                                <div className="p-0 mt-0">
                                    <CustomOtpInput
                                        value={otp}
                                        onChange={(newValue) => {
                                            setOtp(newValue);
                                            setIsValidOtp(true);
                                        }}
                                        onlyNumbers={true}
                                        required={true}
                                        emptyFields={emptyFields}
                                        isValid={isValidOtp}
                                    />
                                </div>
                            }

                            <div className={"p-0 d-flex flex-column gap-4"}>
                                <ButtonNextStep
                                    id="btn_hm_login"
                                    text="login"
                                    click={handleLogin}
                                    disabled={false}
                                />

                                <div className="d-flex align-items-center text-center font-color-shades-400 login-divider">
                                    <span className={"font-color-shades-500 fs-12 px-3"}>{t('or').toLowerCase()}</span>
                                </div>
                                <ButtonNextStep
                                    id="btn_hm_forgot"
                                    text="forgot_password"
                                    className={'btn-background-shades-700 '}
                                    click={handleForgotPassword}
                                    disabled={false}
                                />
                            </div>
                        </form>
                    </div>
                    <div className="position-absolute font-color-primary-600 fs-16px b-16px">
                        {t('ientry_name')}
                    </div>
                </div>
                <div className={"d-none d-lg-block col-lg-7 p-0"}>
                    <HomeAnimatedBackground t={t}/>
                </div>
            </div>

            {loading && <FullPageLoader />}
        </>
    );
};

export default Home;
